/**
 * @overview Search page helpers.
 *
 * @module search/helpers
 */

/**
 * @constant
 * @type {string}
 * @default
*/
export const sortIndexDataKey = 'data-sort-index';

/**
 * Add a data attribute which holds the original sort index value of the filter.
 *
 * @param {Node} filter
 * @param {number} index
 */
export function addSortIndex (filter, index) {
    if (filter && +index >= 0) {
        filter.setAttribute(sortIndexDataKey, index);
    }
}

/**
 * Parse the search area from a url.
 *
 * @param {string} url
 * @returns {string}
 */
export function getSearchArea (url) {
    const areaStr = 'area/';

    return url && url.indexOf(areaStr) > 0
        ? url.split(areaStr).pop()
        : '';
}
